import { requests } from './baseServices'

export const FileServices = {
    uploadImage: (formData) => requests.post('api/files/image', formData),
    upload: (formData) => requests.post('api/files/upload', formData),
    uploadAttachment: (formData) => requests.post('api/files/attachment', formData),
    getAll: (criteria) => requests.get('api/files', criteria),
    //getImage:(filename)=>requests.get(`api/files/image/${filename}`)
    getAllWithOptions: (criteria) => requests.post('api/files/filtered', criteria),
    getDocumentFile: (id) => requests.download(`api/files/document/${id}`),
    getAttachmentFile: (id) => requests.download(`api/files/attachment/${id}`),    
    deleteDocument: (id) => requests.delete(`api/files/document/${id}`),
    getInvoiceFile: (id, showReport) => requests.download(`api/files/invoice/${id}/${showReport}`),
    getReportFile: (clientId, projectId, devId, month) => requests.download(`api/files/report/${clientId}/${projectId}/${devId}/${month}`),
    getFullReportFile: (devId, month) => requests.download(`api/files/fullreport/${devId}/${month}`)
};